<div class="box-video-recording">
    <div class="image-recording algin-center w-100">
        <h2 class="font-bold" style="color: #000000">
            Are you sure you want <br />
            to save these changes? <br />
            <br />
            You cannot revert them if it is saved.
            <br />
        </h2>
    </div>
    <button class="btn-yes-recording font-bold btn-common-style" (click)="onClickSaveFeedback()">Yes, I am.</button>
    <button class="btn-no-recording font-bold btn-common-style" (click)="onClose()">No, I am not.</button>
</div>
